import { useMemo, FC } from 'react';
import { ReactCountryFlag } from 'react-country-flag';
import styles from './BoatColumn.module.scss';
import { BoatColumnProps } from './BoatColumn.props';

const BoatColumn: FC<BoatColumnProps> = ({ flag, boatName, flagInFront = false }) => {
  const flagMemo = useMemo(() => {
    if (flag) {
      return (
        <ReactCountryFlag
          countryCode={flag}
          svg
          style={{
            height: 22,
            width: 'auto',
            borderRadius: 3,
          }}
        />
      );
    }

    return null;
  }, [flag]);

  return (
    <div>
      {flagInFront ? (
        <div className={styles.boatNameContainer}>
          {flagMemo} {boatName}
        </div>
      ) : (
        <div className={styles.boatNameContainer}>
          {boatName} {flagMemo}
        </div>
      )}
    </div>
  );
};

export { BoatColumn };
